import { auth } from "../auth";
import { api } from "../apirest";

const SET_USER = "SET_USER";
const SET_READY = "SET_READY";
const REMOVE_USER = "REMOVE_USER";

const initialState = {
  user: null,
  isReady: false,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return { ...state, user: action.data, isReady: true };
    case SET_READY:
      return { ...state, isReady: action.data };
    case REMOVE_USER:
      return { ...state, user: null, isReady: true };
    default:
      return state;
  }
};

export const userSelector = (state) => state.user;

export const userActions = {
  watchUser() {
    return (dispatch) => {
      auth.onAuthStateChanged(async (user) => {
        try {
          if (!user) {
            dispatch({
              type: REMOVE_USER,
            });

            return;
          }

          const { doc: userData } = await api(
            `/users/findById?idAuth=${user.uid}`
          );
           if (!userData.claims.admin) {
             await auth.signOut();

             return;
           }

          dispatch({
            type: SET_USER,
            data: user,
          });
        } catch (error) {
          console.log({ error });
        }
      });
    };
  },
};

export default userReducer;
